import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ModalPortal } from "../ModalPortal/ModalPortal";
import {
  isPaymentResultStatus,
  PAYMENT_RESULT_FAIL,
  PAYMENT_RESULT_QUERY,
  PAYMENT_RESULT_SUCCESS,
} from "../../utils/paymentResult";
import "./PaymentResultModal.scss";

export const PaymentResultModal = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get(PAYMENT_RESULT_QUERY);

  const goHome = useCallback(() => {
    navigate("/", { replace: true });
  }, [navigate]);

  if (!isPaymentResultStatus(status)) {
    return null;
  }

  const isSuccess = status === PAYMENT_RESULT_SUCCESS;
  const title = isSuccess ? "Оплата прошла успешно" : "Оплата не выполнена";
  const description = isSuccess
    ? "Тариф будет активирован автоматически. Можно вернуться на главную."
    : "Попробуйте позже или свяжитесь с администратором.";

  return (
    <ModalPortal>
      <div className="payment-result-overlay" role="presentation">
        <div
          className={`payment-result-modal payment-result-modal--${
            isSuccess ? PAYMENT_RESULT_SUCCESS : PAYMENT_RESULT_FAIL
          }`}
          role="dialog"
          aria-modal="true"
          aria-labelledby="payment-result-title"
        >
          <h2 id="payment-result-title" className="payment-result-title">
            {title}
          </h2>
          <p className="payment-result-text">{description}</p>
          <button type="button" className="btn btn-primary payment-result-btn" onClick={goHome}>
            На главную
          </button>
        </div>
      </div>
    </ModalPortal>
  );
};
